import('./src/bootstrap');
import('@fsa/app-info');
